import { Icon } from '@cbhq/cds-web/icons';
import { HStack } from '@cbhq/cds-web/layout';
import { Tooltip } from '@cbhq/cds-web/overlays';
import { TextHeadline } from '@cbhq/cds-web/typography';

const filterTooltipContent =
  "These filters will be applied to transactions before they're sent to your webhook.";

export function WebhookFiltersTitle() {
  return (
    <HStack alignItems="center" gap={0.5}>
      <TextHeadline as="h2">Filters</TextHeadline>
      <Tooltip content={filterTooltipContent}>
        <Icon name="info" size="s" color="foregroundMuted" />
      </Tooltip>
    </HStack>
  );
}
